<template>
  <div class="product-block--components row-flex" @click="goProduct">
    <div class="product-img">
      <img :src="info.CoverImage" alt="" srcset="">
    </div>
    <div class="product-info row-flex-eq">
      <h4 class="produt-title ellipsis">{{info.ProductModel}}</h4>
      <div class="product-msg ellipsis">{{info.CategoryName}}</div>
      <div class="product-msg ellipsis">{{info.BrandName}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      info: {
        required: true,
        default: () => {
          return {
            Id: '',
            CoverImage: '',
            ProductModel: '',
            CategoryName: '',
            BrandName: ''
          }
        }
      }
    },
    methods: {
      goProduct() {
        window.location.href = `https://www.51mydao.com/Product/ProductDetail/${this.info.Id}`
      }
    }
  };
</script>
<style lang='scss' scoped>
.product-block--components {
  padding: 10px 0;
  color: $text-main;
  .product-img {
    margin-right: 10px;
    width: 60px;
    height: 60px;
    img {
      width: inherit;
      height: inherit;
    }
  }
  .produt-title {
    margin: 0;
    height: 28px;
    font-size: $font-size-big;
    font-weight: normal;
  }
  .ellipsis {
    max-width: 220px;
  }
  .product-msg {
    font-size: $font-size-small;
  }
}
</style>